// React Basic and Bootstrap
import React, { Component } from "react";
import Seo from "../components/Seo";
import { Container, Row, Modal, ModalBody, Col, Card, CardBody, Media, } from "reactstrap";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import { getUser } from '../service/FetchUtil';
//Import Icons
import Login from "../components/Layout/Login";
import SignUp from "../components/Layout/SignUp";
import { Config } from '../config';

//Pages

//Import css
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/css/style.css";

//Import Images
import bg1 from "../../src/assets/images/bulut12/sliderr/hakkimizda2.jpg";
// 3. slide e-Ticaret entegrasyon logoları
import etTrendyol from "../assets/images/bulut12/eticaret/trendyol.png";
import etHepsiburada from "../assets/images/bulut12/eticaret/hepsiburada.png";
import etN11 from "../assets/images/bulut12/eticaret/n11.png";
import etCiceksepeti from "../assets/images/bulut12/eticaret/ciceksepeti.png";
import etPazarama from "../assets/images/bulut12/eticaret/pazarama.png";
import etEpttavm from "../assets/images/bulut12/eticaret/epttavm.png";
import etFarmazon from "../assets/images/bulut12/eticaret/farmazon.svg";
import etWoocommerce from "../assets/images/bulut12/eticaret/woocommerce.png";
import etIkas from "../assets/images/bulut12/eticaret/ikas.svg";
import etTsoft from "../assets/images/bulut12/eticaret/tsoft.svg";
import etAmazon from "../assets/images/bulut12/eticaret/amazon.png";
// Banka entegrasyon logoları
import bankGaranti from "../assets/images/bulut12/bankalar/garanti.png";
import bankIsbank from "../assets/images/bulut12/bankalar/isbank.png";
import bankZiraat from "../assets/images/bulut12/bankalar/ziraat.png";
import bankYapikredi from "../assets/images/bulut12/bankalar/yapikredi.png";
import bankAkbank from "../assets/images/bulut12/bankalar/akbank.png";
import bankQnb from "../assets/images/bulut12/bankalar/qnb.png";
import bankHalkbank from "../assets/images/bulut12/bankalar/halkbank.png";
import bankVakifbank from "../assets/images/bulut12/bankalar/vakifbank.png";
import bankVakifKatilim from "../assets/images/bulut12/bankalar/vakifkatilim.png";
import bankAlbaraka from "../assets/images/bulut12/bankalar/albaraka.png";
import bankKuveytturk from "../assets/images/bulut12/bankalar/kuveytturk.png";
import bankTurkiyeFinans from "../assets/images/bulut12/bankalar/turkiyefinans.png";
import bankZiraatKatilim from "../assets/images/bulut12/bankalar/ziraatkatilim.png";
import personel from "../assets/images/bulut12/coksebepvar/personelyonetimi.png";
import muhasebe from "../assets/images/bulut12/coksebepvar/onmuhasebe.png";
import finans from "../assets/images/bulut12/coksebepvar/finans.png";
import depo from "../assets/images/bulut12/coksebepvar/depoyonetimi.png";
import entegrasyon from "../assets/images/bulut12/coksebepvar/entegrasyonlar.png";
import burdanbi from "../assets/images/bulut12/coksebepvar/burdanbi.png";
import posguru from "../assets/images/bulut12/coksebepvar/posguru.png";
import perakende from "../assets/images/bulut12/coksebepvar/perakende.png";
import kullanim from "../assets/images/bulut12/nedenbulut12/kolaykullanim.gif";
import kullanici from "../assets/images/bulut12/nedenbulut12/kullaniciodakli.gif";
import erisim from "../assets/images/bulut12/nedenbulut12/heryerdenerisim.gif";
import guvenilir from "../assets/images/bulut12/nedenbulut12/guvenilirhizmet.gif";
import ekip from "../assets/images/bulut12/nedenbulut12/tecrubeliekip.gif";
import cozum from "../assets/images/bulut12/nedenbulut12/biraradacozumler.gif";
import stokgif from "../assets/images/bulut12/stok.gif";
import finansgif from "../assets/images/bulut12/finans.gif";
import personelgif from "../assets/images/bulut12/personel.gif";
import eticaretgif from "../assets/images/bulut12/eticaret.gif";
import perakendegif from "../assets/images/bulut12/perakende.gif";
import uretimimg from "../assets/images/bulut12/depo/avantajlari/product-management.png";
import siparisgif from "../assets/images/bulut12/siparis.gif";
import edonusumgif from "../assets/images/bulut12/edonusum.gif";
import burdanbigif from "../assets/images/bulut12/burdanbi.gif";

//client

import arroww from "../assets/images/bulut12/1.png";
import { HashLink } from "react-router-hash-link";
// import { Pricings } from "../config/pricingOptions";


class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      loginModal: false,
      signUpModal: false,
      items: [
        {
          image: bg1,
          class: "slider-rtl-2",
          h3: "Kurulum Yok, Sınır Yok.",
          p: "Tamamen Bulut ERP",
          p2: "",
          text: "Bulut12 gerçek bir bulut ERP'dir: bilgisayarınıza hiçbir şey kurmadan, internetin olduğu her yerden tarayıcınızdan yönetin. iOS ve Android uygulamalarımızla işletmeniz daima cebinizde.",
          link: "#",
        },
        {
          image: bg1,
          class: "slider-rtl-2 slide-erisim2",
          h3: "Dilediğiniz Cihazdan, Dilediğiniz Yerden Erişin",
          p: "",
          p2: "",
          text: "İşletmenizi yönetmek için tek bir cihaza bağlı kalmayın. İnternetin olduğu her yerden; bilgisayarınızdan, tabletinizden veya telefonunuzdan Bulut12'ye anında ulaşın.",
          link: "#",
        },
        {
          image: bg1,
          class: "slider-rtl-2 slide-eticaret",
          eticaretLogos: true,
          h3: "Tek Yerden e-Ticaret Sistemlerinizi Yönetin!",
          p: "",
          p2: "",
          text: "Trendyol, Hepsiburada, n11, Çiçeksepeti ve daha fazlası... Tüm pazaryeri ve e-Ticaret sitelerinizden gelen sipariş ve faturaları tek panelden yönetin.",
          link: "#",
        },
        // {
        // //   image: bg2,
        // //   class: "slider-rtl-3",
        // //   h3: "Tek ekran",
        // //   p: "Üzerinden Birçok İşlemi",
        // //   p2: "Kolayca Yönetin!",
        // //   text: "Tüm ön muhasebe işlemlerinizi tek bir program ile tek bir ekrandan yönetin, zamanın değerini bilin!",
        // //   link: "#",
        // // },
      ],
      features: [
        {
          id: 1,
          image: perakende,
          icon: "uil uil-airplay d-block rounded h3 mb-0",
          heading: "CARİ HESAP TAKİBİ",
          text: "Toptan ve Perakende operasyonlarınızda, ürünlerinizin satın alınışından kasaya kadar olan süreçlerini anlık olarak takip edin, işletmenizin kârlılığını artırın!",

        },

        {
          id: 2,
          image: muhasebe,
          icon: "uil uil-credit-card-search d-block rounded h3 mb-0",
          heading: "FATURA TAKİBİ",
          text: "Kullanıcı odaklı, kolay arayüz tasarımı ile ön muhasebe işlemlerinizi pratik bir şekilde sorun yaşamadan yönetin.",

        },
        {
          id: 3,
          image: finans,
          icon: "uil uil-clipboard-alt d-block rounded h3 mb-0",
          heading: "GELİR-GİDER TAKİBİ",
          text: "İşletmenizin tahsilat, ödeme ve diğer mali işlemlerini  anlık olarak takip edebileceğiniz gibi, tanımladığınız banka bilgileriniz sayesinde de hesap hareketlerinizi kolayca görüntüleyebilirsiniz.",

        },
        {
          id: 4,
          image: personel,
          icon: "uil uil-ruler-combined d-block rounded h3 mb-0",
          heading: "MASRAF KARTLARI",
          text: "İşletmenizin tüm gider kalemlerini masraf kartlarıyla kategorize edin, harcamalarınızı kalem kalem takip ederek bütçenizi kontrol altında tutun.",

        },
      ],
      features2: [
        {
          id: 1,
          image: depo,
          icon: "uil uil-rocket",
          heading: "ÇEK-SENET",
          text: "Müşteri ve tedarikçilerinize ait çek ve senetlerinizi tek ekrandan yönetin, vade tarihlerini takip ederek tahsilat ve ödemelerinizi aksatmayın.",

        },
        {
          id: 2,
          image: entegrasyon,
          icon: "uil uil-rocket",
          heading: "KASA-BANKA",
          text: "Kasa ve banka hesaplarınızı tek panelden yönetin, tüm tahsilat ve ödeme hareketlerinizi anlık olarak takip ederek nakit akışınızı kontrol altında tutun.",

        },


        {
          id: 3,
          image: burdanbi,
          icon: "uil uil-file-alt",
          heading: "BURDANBİ",
          text: "Aklında ne varsa hızlı sipariş için sadece BurdanBi yeterli. İster webden ister uygulamadan.",

        },
        {
          id: 4,
          image: posguru,
          icon: "uil uil-search",
          heading: "BULUT12 POS",
          text: "Market ve restoranlar için tamamen web tabanlı yeni nesil POS çözümü. Kurulum gerektirmeden, internet bağlantısı olan dilediğiniz cihazda tarayıcınız üzerinden hızlıca satış yapın.",

        },


        //{
        //    id: 9,
        //    icon: "uil uil-search",
        //    heading: "Özet Tablosu",
        //    desc: "Özet tablosundan işletmenize ait finans hareketlerinizi ve satış analizlerinizi takip edebilirsiniz.",

        //},
      ],
      features3: [
        {
          id: 1,
          image: stokgif,
          heading: "Depo ve Stok Yönetimi",
          text: "Depo ve Stok Takibi'nizi pratik bir şekilde yöneterek, ürünlerinizin güncel durumunu kontrol edin.",
          link: "/depostokyonetimi",
        },

        {
          id: 2,
          image: finansgif,
          icon: "uil uil-credit-card-search d-block rounded h3 mb-0",
          heading: "Finans Hareketleri",
          text: "İşletmenizin tahsilat, ödeme ve diğer mali işlem hareketlerini güncel olarak görüntüleyin.",
          link: "/finansyonetimi",
        },
        {
          id: 3,
          image: perakendegif,
          icon: "uil uil-clipboard-alt d-block rounded h3 mb-0",
          heading: "Perakende Yönetimi",
          text: "Tüm operasyon süreçlerinizi ve stok hacminizdeki büyümeyi takip edip, kâr oranlarınızı artırın!",
          link: "/perakende",
        },
        {
          id: 4,
          image: personelgif,
          icon: "uil uil-ruler-combined d-block rounded h3 mb-0",
          heading: "Personel Takibi",
          text: "Personelinize ait tüm ödeme, tahsilat, izin ve bordro işlemlerini tek ekrandan takip edip, yönetebilirsiniz.",
          link: "/personelyonetimi",
        },
        {
          id: 5,
          image: eticaretgif,
          icon: "uil uil-ruler-combined d-block rounded h3 mb-0",
          heading: "e-Ticaret Entegrasyonu",
          text: "e-Ticaret platformlarından mağazanız adına aldığınız siparişleri veya iadeleri kolayca Bulut12'ye aktarın.",
          link: "/eticaret",
        },
        {
          id: 6,
          image: edonusumgif,
          icon: "uil uil-ruler-combined d-block rounded h3 mb-0",
          heading: "E-Dönüşüm",
          text: "Tüm resmi evraklarınızı ve faturalarınızı tek tuşla oluşturun. Dijital ortamda kaybolma derdi olmadan arşivleyin.",
          link: "/#",
        },
        {
          id: 7,
          image: siparisgif,
          icon: "uil uil-ruler-combined d-block rounded h3 mb-0",
          heading: "Sipariş ve Teklif Yönetimi",
          text: "Teklif ve siparişlerinizi tek ekrandan yönetin; onaylanan teklifleri tek tuşla siparişe ya da faturaya dönüştürün, tedarik zincirinizi aksatmayın.",
          link: "/siparisyonetimi",
        },
        {
          id: 8,
          image: burdanbigif,
          icon: "uil uil-ruler-combined d-block rounded h3 mb-0",
          heading: "Satın Alma",
          text: "Tedarikçilerinizden alış sipariş ve faturalarınızı tek ekrandan yönetin; stok ve maliyet hareketlerinize anında yansısın.",
          link: "/onmuhasebesyf",
        },
        {
          id: 9,
          image: uretimimg,
          icon: "uil uil-ruler-combined d-block rounded h3 mb-0",
          heading: "Üretim",
          text: "Reçete, sarf ve maliyet takibiyle üretim süreçlerinizi yönetin; hammaddeden mamule tüm akışı tek yerden kontrol edin.",
          link: "/sektorler",
        },
      ],
      // pricings: Pricings(),

      isOpen: false,
      collapse1: false,
      col1: false,
      col2: false,
      col3: false,
      col4: false,
      col5: false,
      col6: false,

      step1: true,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      step6: false,
    };
    this.openModal = this.openModal.bind(this);
    this.t_col1 = this.t_col1.bind(this);
    this.t_col2 = this.t_col2.bind(this);
    this.t_col3 = this.t_col3.bind(this);
    this.t_col4 = this.t_col4.bind(this);
    this.t_col5 = this.t_col5.bind(this);
    this.t_col6 = this.t_col6.bind(this);
    this.t_col7 = this.t_col7.bind(this);
    this.t_col8 = this.t_col8.bind(this);
    this.t_col9 = this.t_col9.bind(this);
    this.states =
    {
      successMsg: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(event) {
    event.preventDefault();
    this.setState({ successMsg: true });
  }
  openModal() {
    this.setState({ isOpen: true });
  }

  toggleLoginModal = () => {
    this.setState((prevState) => ({
      loginModal: !prevState.loginModal,
      signUpModal: false
    }));
  };

  toggleSignUpModal = () => {
    this.setState((prevState) => ({
      loginModal: false,
      signUpModal: !prevState.signUpModal,
    }));
  };
  state = { show: true, }
  toggle = () => this.setState((currentState) => ({ show: !currentState.show }));
  t_col1() {
    this.setState({
      col1: !this.state.col1,
      col2: false,
      col3: false,
      col4: false,
      col5: false,
      col6: false,
      col7: false,
      col8: false,
      col9: false,
    });
  }
  t_col2() {
    this.setState({
      col2: !this.state.col2,
      col1: false,
      col3: false,
      col4: false,
      col5: false,
      col6: false,
      col7: false,
      col8: false,
      col9: false,
    });
  }
  t_col3() {
    this.setState({
      col3: !this.state.col3,
      col2: false,
      col1: false,
      col4: false,
      col5: false,
      col6: false,
      col7: false,
      col8: false,
      col9: false,
    });
  }
  t_col4() {
    this.setState({
      col4: !this.state.col4,
      col2: false,
      col3: false,
      col1: false,
      col5: false,
      col6: false,
      col7: false,
      col8: false,
      col9: false,
    });
  }
  t_col5() {
    this.setState({
      col5: !this.state.col5,
      col2: false,
      col3: false,
      col1: false,
      col4: false,
      col6: false,
      col7: false,
      col8: false,
      col9: false,
    });
  }

  t_col6() {
    this.setState({
      col6: !this.state.col6,
      col2: false,
      col3: false,
      col1: false,
      col4: false,
      col5: false,
      col7: false,
      col8: false,
      col9: false,
    });
  }

  t_col7() {
    this.setState({
      col7: !this.state.col7,
      col2: false,
      col3: false,
      col1: false,
      col4: false,
      col5: false,
      col6: false,
      col8: false,
      col9: false,
    });
  }

  t_col8() {
    this.setState({
      col8: !this.state.col8,
      col2: false,
      col3: false,
      col1: false,
      col4: false,
      col5: false,
      col6: false,
      col7: false,
      col9: false,
    });
  }

  t_col9() {
    this.setState({
      col9: !this.state.col9,
      col2: false,
      col3: false,
      col1: false,
      col4: false,
      col5: false,
      col6: false,
      col7: false,
      col8: false,
    });
  }


  componentDidMount() {
    var e1 = document.getElementsByClassName("slick-slide");
    for (var i = 0; i < 2; i++) {
      if (i === 0) e1[i].style.backgroundImage = `url(${bg1})`; //Kıvırcık
      // if (i === 1) e1[i].style.backgroundImage = `url(${bg2})`;
    }
  }
  render() {
    const user = getUser();
    var settings = {
      lazyLoad: true,
      autoplay: true,
      autoplaySpeed: 7000,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      pauseOnHover: false,
      showArrows: true,
      infinite: true,


    };
    const settings2 = {
      dots: true,
      infinite: true,
      autoplaySpeed: 4000,
      autoplay: true,
      slidesToShow: 3,
      slidesToScroll: 3,
    };
    const settings3 = {
      dots: true,
      infinite: true,
      autoplaySpeed: 4000,
      autoplay: true,
      slidesToShow: 3,
      slidesToScroll: 3,
    };
    const settings4 = {
      dots: true,
      infinite: true,
      autoplaySpeed: 4000,
      autoplay: true,
      slidesToShow: 3,
      slidesToScroll: 3,
    };


    return (

      <React.Fragment>
        <Seo
            title="Bulut12 - Tamamen Bulut ERP"
            description="Bulut12, kurulum gerektirmeyen %100 web tabanlı bulut ERP ve ön muhasebe programıdır. e-Fatura, e-Arşiv, stok, finans ve e-Ticaret entegrasyonlarını tek panelden yönetin. 7 gün ücretsiz deneyin."
            path="/"
            keywords="bulut ERP, web tabanlı ERP, online ön muhasebe programı, bulut muhasebe, e-Fatura programı, e-Arşiv, KOBİ ERP, stok takip programı, Bulut12"
        />
        <section className="main-slider erp_banner_area_two">
          <Slider className="slides"{...settings}>
            {this.state.items.map((item, key) => (
              <li
                key={key}
                className={"bg-slider d-flex align-items-center " + item.class}
              >
                {item.eticaretLogos &&
                  <div className="eticaret-logo-wrap">
                    {[etTrendyol, etHepsiburada, etN11, etCiceksepeti, etPazarama,
                      etEpttavm, etAmazon, etFarmazon, etWoocommerce, etIkas, etTsoft].map((logo, li) => (
                      <div className="eticaret-logo-cell" key={li}>
                        <img src={logo} alt="" />
                      </div>
                    ))}
                    <div className="eticaret-logo-cell eticaret-logo-more">ve dahası…</div>
                  </div>
                }
                <Container>
                  <Row className="slider-top align-items-center col-lg-12 col-md-6">
                    <Col className="slider-desc">
                      <div className="title-heading">
                        <p className="home-slider1 pera-h1 title-white font-weight-bold h1test">
                          {item.h3} {item.p} {item.p2}
                        </p>
                        <p className="para-desc font-weight-500 para-dark">
                          {item.text}
                        </p>
                        <div className="mt-4 slider-btn">
                          {user ?
                            (!user.data ? <HashLink to="/fiyatlar"
                              testid="btnregister"
                              className="btn btn-stildetay btn-primary ml-10  font-weight-500 mb-3 rounded-pill"
                            >
                              7 Gün Ücretsiz Deneyin
                            </HashLink> : null) :
                            <HashLink to="/fiyatlar"
                              testid="btnregister"
                              className="btn btn-stildetay btn-primary ml-10  font-weight-500 mb-3 rounded-pill"
                              onClick={this.toggleLoginModal}
                            >
                              7 Gün Ücretsiz Deneyin
                            </HashLink>
                          }
                          <Link to="/wp" className="btn btn-detayli btnstildetay btn-outline-primary  font-weight-500 mb-3 rounded-pill">
                            <i className="uil uil-whatsapp"></i>&nbsp;Detaylı Bilgi
                          </Link>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <a className="btn btn-outline-primary font-weight-500 mb-3 rounded-pill btnstilnum" href="tel:08503020304">
                          <i className="uil uil-phone"></i>&nbsp;0(850) 302 0304</a>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </li>
            ))}
          </Slider>
        </section>
        <Container className="baslik container-neden">
          <Row className="justify-content-center">
            <div className="col-12 text-center">
              {/* render Section title */}
              <h3 className="ndnblt12">NEDEN BULUT12?</h3>
            </div>
            <Col className="col-ndn" lg={12}>
              <Row>
                <Col md={2} xs={6} sm={4} className="mt-4">
                  <div className="ndn-card">
                    <div className="ndn-icon-wrap"><img src={kullanici} alt="Kullanıcı Odaklı" /></div>
                    <p className="ndn-title">Kullanıcı Odaklı</p>
                  </div>
                </Col>
                <Col md={2} xs={6} sm={4} className="mt-4">
                  <div className="ndn-card">
                    <div className="ndn-icon-wrap"><img src={kullanim} alt="Kolay Kullanım" /></div>
                    <p className="ndn-title">Kolay Kullanım</p>
                  </div>
                </Col>
                <Col md={2} xs={6} sm={4} className="mt-4">
                  <div className="ndn-card">
                    <div className="ndn-icon-wrap"><img src={erisim} alt="Her Yerden Erişim" /></div>
                    <p className="ndn-title">Her Yerden Erişim</p>
                  </div>
                </Col>
                <Col md={2} xs={6} sm={4} className="mt-4">
                  <div className="ndn-card">
                    <div className="ndn-icon-wrap"><img src={guvenilir} alt="Güvenilir Hizmet" /></div>
                    <p className="ndn-title">Güvenilir Hizmet</p>
                  </div>
                </Col>
                <Col md={2} xs={6} sm={4} className="mt-4">
                  <div className="ndn-card">
                    <div className="ndn-icon-wrap"><img src={ekip} alt="Tecrübeli Ekip" /></div>
                    <p className="ndn-title">Tecrübeli Ekip</p>
                  </div>
                </Col>
                <Col md={2} xs={6} sm={4} className="mt-4">
                  <div className="ndn-card">
                    <div className="ndn-icon-wrap"><img src={cozum} alt="Bir Arada Çözümler" /></div>
                    <p className="ndn-title">Bir Arada Çözümler</p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={11}>
              <div className="veri-panel">
                <span className="veri-badge">Güçlü Altyapı</span>
                <h3 className="verimerkezi">En Güvenilir Veri Merkezi İle Çalışıyoruz</h3>
                <p className="pveri">Türkiye’deki en büyük Tier 3 sertifikasına sahip veri merkezi ile çalışmaktayız. Güçlü teknolojisi ve üstün network
              altyapısı sayesinde <a href="https://www.turkcell.com.tr/kurumsal/dijital-is-servisleri/veri-merkezi-data-center" target="_blank">Turkcell Temelli Veri Merkezi</a>, Bulut12 müşterilerine üstün güvenlikli hizmetler sunmaktadır.</p>
              </div>
            </Col>
          </Row>
        </Container>
        <section className="section gercek-bulut-sec">
          <Container>
            <div className="col-12 text-center">
              <h2 className="gb-title">Tamamen Web Tabanlı, Gerçek Bulut ERP</h2>
              <p className="gb-sub">Bulut12, kurulum ve sunucu gerektirmeden tamamen tarayıcı üzerinden çalışır. İşletmeniz teknik yük altına girmeden bulutun tüm avantajlarından yararlanır.</p>
            </div>
            <Row className="justify-content-center gb-row mt-4">
              <Col lg={5} md={6} className="mt-4">
                <div className="gb-card gb-old">
                  <i className="uil uil-frown gb-sad"></i>
                  <span className="gb-badge gb-badge-old">Geleneksel Yöntem</span>
                  <ul className="gb-list">
                    <li className="gb-no">Yazılım her cihaza ayrı ayrı kurulur</li>
                    <li className="gb-no">Sunucu, bakım, firewall ve modem port ayarı gerekir</li>
                    <li className="gb-no">Güncellemeler elle yapılır</li>
                    <li className="gb-no">Veri yedeklemesi sizin sorumluluğunuzdadır</li>
                    <li className="gb-no">Cihaza virüs veya fidye yazılımı bulaşabilir</li>
                    <li className="gb-no">Elektrik veya cihaz arızasında işiniz durur</li>
                    <li className="gb-no">Erişim kurulu cihazlarla sınırlıdır</li>
                    <li className="gb-no">Mobil kullanım çoğu zaman kısıtlıdır</li>
                  </ul>
                </div>
              </Col>
              <Col lg={5} md={6} className="mt-4">
                <div className="gb-card gb-new">
                  <i className="uil uil-trophy gb-trophy"></i>
                  <span className="gb-badge gb-badge-new">Bulut12 ile</span>
                  <ul className="gb-list">
                    <li className="gb-yes">Kurulum yok; tarayıcıdan anında başlarsınız</li>
                    <li className="gb-yes">Sunucu, bakım, firewall veya port açma derdi yoktur</li>
                    <li className="gb-yes">Her zaman otomatik güncel kalır</li>
                    <li className="gb-yes">Verileriniz otomatik olarak yedeklenir, kaybolmaz</li>
                    <li className="gb-yes">Virüs ve fidye yazılımı riski olmaz</li>
                    <li className="gb-yes">Elektrik veya cihaz arızası işinizi durdurmaz</li>
                    <li className="gb-yes">İnternet olan her yerden, her cihazdan erişirsiniz</li>
                    <li className="gb-yes">iOS ve Android uygulamalarıyla işletmenizi cebinizden yönetirsiniz</li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section guncel-sec">
          <Container>
            <Row className="align-items-center">
              <Col lg={6} md={12} className="mb-4">
                <h2 className="guncel-title">Mevzuatı, Yönetmelikleri Bulut12'ye Bırakın; Siz İşinize Odaklanın</h2>
                <p className="guncel-text">e-Fatura, e-Arşiv ve değişen yasal düzenlemeler Bulut12'de kendiliğinden güncellenir. Güncelleme yüklemek, sürüm farklarıyla uğraşmak ya da son tarihleri kaçırmak yok — siz işinize odaklanın.</p>
                <ul className="guncel-list">
                  <li>Yasal değişiklikler işletmenize otomatik yansır</li>
                  <li>Güncelleme yükleme derdi olmaz</li>
                  <li>Her zaman en güncel sürümle çalışırsınız</li>
                </ul>
              </Col>
              <Col lg={6} md={12} className="text-center">
                <div className="guncel-visual">
                  <div className="guncel-head">
                    <i className="uil uil-sync guncel-ico"></i>
                    <span className="guncel-head-text">e-Dönüşüm — Sürekli Güncel</span>
                  </div>
                  <div className="guncel-chips">
                    <Link to="/efatura" className="guncel-chip"><i className="uil uil-check-circle"></i> e-Fatura</Link>
                    <Link to="/earsiv" className="guncel-chip"><i className="uil uil-check-circle"></i> e-Arşiv</Link>
                    <Link to="/eirsaliye" className="guncel-chip"><i className="uil uil-check-circle"></i> e-İrsaliye</Link>
                    <Link to="/esmm" className="guncel-chip"><i className="uil uil-check-circle"></i> e-SMM</Link>
                    <Link to="/mustahsilmakbuzu" className="guncel-chip"><i className="uil uil-check-circle"></i> e-Müstahsil</Link>
                    <div className="guncel-chip"><i className="uil uil-check-circle"></i> Beyannameler</div>
                    <div className="guncel-chip"><i className="uil uil-check-circle"></i> Yeni Mevzuat</div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section banka-sec">
          <Container>
            <Row className="align-items-center">
              <Col lg={6} md={12} className="mb-4">
                <h2 className="guncel-title">Banka Hesaplarınız Bulut12 ile Konuşsun</h2>
                <p className="guncel-text">Banka hesaplarınızı bağlayın; gelen ve giden tüm hareketler Bulut12'ye otomatik aktarılsın. Tahsilat ile ödemeleriniz cari hesaplarınızla eşleşsin, banka mutabakatı saniyeler sürsün.</p>
                <ul className="guncel-list">
                  <li>Hesap hareketleri otomatik aktarılır</li>
                  <li>Tahsilat ve ödemeler cariyle eşleşir</li>
                  <li>Nakit akışınızı tek ekrandan anlık görürsünüz</li>
                </ul>
              </Col>
              <Col lg={6} md={12}>
                <div className="banka-logos">
                  {[
                    { img: bankGaranti, name: "Garanti BBVA" },
                    { img: bankIsbank, name: "Türkiye İş Bankası" },
                    { img: bankZiraat, name: "Ziraat Bankası" },
                    { img: bankYapikredi, name: "Yapı Kredi" },
                    { img: bankAkbank, name: "Akbank" },
                    { img: bankQnb, name: "QNB" },
                    { img: bankHalkbank, name: "Halkbank" },
                    { img: bankVakifbank, name: "VakıfBank" },
                    { img: bankVakifKatilim, name: "Vakıf Katılım" },
                    { img: bankAlbaraka, name: "Albaraka" },
                    { img: bankKuveytturk, name: "Kuveyt Türk" },
                    { img: bankTurkiyeFinans, name: "Türkiye Finans" },
                    { img: bankZiraatKatilim, name: "Ziraat Katılım" },
                  ].map((bnk, bi) => (
                    <div className="banka-logo-cell" key={bi}>
                      <img src={bnk.img} alt={bnk.name + " entegrasyonu"} title={bnk.name} />
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section style={{ background: "#ffffff" }}>
          <Container className="justify-content-center">
            <Row className='row justify-content-center mt-0 p-5 uclu-col'>
              <p className="mt-4 h3test-nlr text-l">Bulut12 ile Neler Yapabilirsiniz?</p>
              <p className="text-l nlr-p mt-2">Fatura, cari hesap ve kasa-banka işlemlerinizi hızlıca yaparken depo ve stok
                süreçlerinizi de aynı panelden yönetin. İşletmenizin tüm operasyonu, birbirine bağlı tek bir sistemde toplanır.
              </p>
              <Row className="mt-5 bulut-nlrrow">
                {this.state.features3.map((items, key) => (
                  <Col className="text-align-left" xl={4} lg={4} md={6} xs={12} sm={12}>
                    <Card className="mt-3 mb-3 bulut-nlr modul-card">
                      <CardBody className="p-4">
                        <div className="modul-icon">
                          <img className="img-modul" style={{ width: '46px', height: '46px' }} src={items.image} />
                        </div>
                        <h4 className="modul-title mt-3">{items.heading}</h4>
                        <p className="pera-p modul-text mt-2">{items.text}</p>
                        <span>
                          <img className="mb-2" src={arroww} />
                          <Link to={items.link} className="link ml-2 explore-btn" style={{ color: '#223d7f', fontSize: '18px' }}>
                            <a href={items.link}>KEŞFET{" "}</a>
                          </Link>
                        </span>
                      </CardBody>
                    </Card>
                  </Col>))}
              </Row>
              <div className="mt-5 pt-4 nlr-button" style={{}}>
                {user && user.data ? null :
                  <HashLink to="/fiyatlar" className="ondort-btn btn btn-outline-primary font-weight-500 mb-3 rounded-pill active">
                    7 Gün Ücretsiz Deneyin
                  </HashLink>
                }
                {user && user.data ? null :
                  <text className="ml-4 mr-1 text-dark yada">ya da</text>
                }
                {user && user.data ?
                  <Link to="/wp" style={{ position: 'relative', left: '35% ' }} className="bizimle-ile-btn btn btn-outline-primary  font-weight-500 mb-3  rounded-pill">
                    Bizimle İletişime Geçin
                  </Link> :
                  <Link to="/wp" className="bizimle-ile-btn btn btn-outline-primary  font-weight-500 mb-3  rounded-pill">
                    Bizimle İletişime Geçin
                  </Link>}
                <p style={{ color: 'gray' }} className="ucretsizp">(Ücretsiz deneme sürecinde kredi kartı bilgisi istenmez.)</p>
              </div>
            </Row>
          </Container>
        </section>
        <section className="section gelismis-mobil-sec">
          <Container>
            <Row className="align-items-center">
              <Col lg={6} md={12} className="mb-4">
                <h2 className="guncel-title">Gelişmiş Mobil Yönetim</h2>
                <p className="guncel-text">İşletmenizi telefonunuzdan yönetin. iOS ve Android uygulamalarımızla satış, tahsilat, stok ve faturalarınıza her an, her yerden ulaşın; sahadayken bile tam kontrol sizde.</p>
                <ul className="guncel-list">
                  <li>Satış, sipariş ve tahsilat işlemleri</li>
                  <li>Anlık stok ve cari hesap takibi</li>
                  <li>Fatura oluşturma ve paylaşma</li>
                </ul>
                <Link to="/mobil" className="btn btn-outline-primary rounded-pill mt-3 pl-4 pr-4 font-weight-500">Detaylı Bilgi</Link>
              </Col>
              <Col lg={6} md={12} className="text-center">
                <div className="guncel-visual">
                  <div className="guncel-head">
                    <i className="uil uil-mobile-android-alt guncel-ico"></i>
                    <span className="guncel-head-text">Bulut12 Mobil</span>
                  </div>
                  <div className="guncel-chips">
                    <div className="guncel-chip"><i className="uil uil-check-circle"></i> Satış</div>
                    <div className="guncel-chip"><i className="uil uil-check-circle"></i> Tahsilat</div>
                    <div className="guncel-chip"><i className="uil uil-check-circle"></i> Stok</div>
                    <div className="guncel-chip"><i className="uil uil-check-circle"></i> Fatura</div>
                    <div className="guncel-chip"><i className="uil uil-check-circle"></i> iOS</div>
                    <div className="guncel-chip"><i className="uil uil-check-circle"></i> Android</div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section sektorler-sec">
          <Container>
            <div>
              <p className="sektorler-h3test text-center">Sektörler</p>
              <p className="sektorler-ptest">Hızla gelişen sektörleri yakından takip ederek işletmelere profesyonel çözümlerle yön vermekteyiz.</p>
            </div>
            <Row className="mt-5">
              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Tekstil-Hazır Giyim</h4>
                  </Media>
                </div>
              </Col>

              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">İnşaat-Yapı</h4>
                  </Media>
                </div>
              </Col>

              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Mobilya</h4>
                  </Media>
                </div>
              </Col>

              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Toptan-Perakende</h4>
                  </Media>
                </div>
              </Col>

              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Üretim</h4>
                  </Media>
                </div>
              </Col>

              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Elektronik-Bilişim</h4>
                  </Media>
                </div>
              </Col>

              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">e-Ticaret</h4>
                  </Media>
                </div>
              </Col>

              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Yiyecek-İçecek</h4>
                  </Media>
                </div>
              </Col>

              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Sağlık-Spor</h4>
                  </Media>
                </div>
              </Col>
              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Hizmet</h4>
                  </Media>
                </div>
              </Col>
              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Serbest Meslek</h4>
                  </Media>
                </div>
              </Col>
              <Col lg={3} md={6} sm={6} className="mt-3">
                <div className="d-flex key-feature align-items-center p-3 rounded shadow">
                  <img className="mt-32mb-2 mr-3" src={arroww} />
                  <Media body>
                    <h4 className="title mb-0">Danışmanlık</h4>
                  </Media>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Modal
          isOpen={this.state.loginModal}
          tabIndex="-1"
          centered
          contentClassName="rounded shadow-lg border-0 overflow-hidden"
          toggle={this.toggleLoginModal}
        >
          <ModalBody className="py-5">
            <Login config={Config} onSignUp={this.toggleSignUpModal} />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.signUpModal}
          tabIndex="-1"
          centered
          contentClassName="rounded shadow-lg border-0 overflow-hidden"
          toggle={this.toggleSignUpModal}
        >
          <ModalBody className="py-5">
            <SignUp onLogin={this.toggleLoginModal} />
          </ModalBody>
        </Modal>
      </React.Fragment>
    )

  }

}

export default withRouter(withTranslation()(HomePage));